var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Sheet',{staticClass:"container"},[_c('h1',{staticClass:"success"},[_vm._v("登記成功")]),_c('div',[_vm._v(" 請按此 "),_c('el-button',{staticStyle:{"margin":"0 2px"},attrs:{"type":"success"},on:{"click":_vm.toBooking}},[_vm._v(" 繼續借用 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }